import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { $crud } from "../../utils/CrudFactory";

const InsuranceDetailsModal = ({
  open,
  onClose,
  insuranceDetails,
  setInsuranceDetails,
  setInsuranceModalOpen,
  setDriver,
  driver,
}) => {
  const handleInsuranceChange = (event) => {
    const { name, value } = event.target;
    setInsuranceDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateInsuranceDetails = async () => {
    try {
      const expDate = new Date(insuranceDetails.expiry);
      expDate.setHours(23, 59, 59, 999);
      const { data } = await $crud.put("admin/insurance-details-driver", {
        _id: driver._id,
        ...insuranceDetails,
        expiry: expDate,
      });
      setDriver((prev) => ({
        ...prev,
        insuranceDetails: data.insuranceDetails,
      }));
      setInsuranceDetails({
        name: data.insuranceDetails?.name || "",
        coverageAmount:
          data.insuranceDetails?.coverageAmount || "",
        policyNumber: data.insuranceDetails?.policyNumber || "",
        expiry: data.insuranceDetails?.expiry || "",
      });
      setInsuranceModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "visible",
          minWidth: { xs: "90vw", md: "760px" },
          width: "760px",
          maxWidth: "90vw",
          padding: "18px 28px 30px",
          bgcolor: "white",
        },
      }}
    >
      <DialogContent sx={{ p: 0, overflow: "visible" }}>
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              color: "#000",
            }}
          >
            ×
          </IconButton>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "26px",
              fontWeight: 700,
              color: "#111827",
              mt: 3,
              mb: 4,
            }}
          >
            Insurance Details
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 3,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}>
                Name of Insurance
              </Typography>
              <TextField
                fullWidth
                name="name"
                value={insuranceDetails.name}
                onChange={handleInsuranceChange}
                placeholder="Enter Your Name"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#F3F4F6",
                    "& fieldset": {
                      borderColor: "rgba(17, 24, 39, 0.25)",
                    },
                  },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}>
                Coverage Amt
              </Typography>
              <TextField
                fullWidth
                name="coverageAmount"
                type="number"
                value={insuranceDetails.coverageAmount}
                onChange={handleInsuranceChange}
                placeholder="Type Coverage Amount"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#F3F4F6",
                    "& fieldset": {
                      borderColor: "rgba(17, 24, 39, 0.25)",
                    },
                  },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}>
                Policy Number
              </Typography>
              <TextField
                fullWidth
                name="policyNumber"
                value={insuranceDetails.policyNumber}
                onChange={handleInsuranceChange}
                placeholder="Enter Your Policy Number"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "#F3F4F6",
                    "& fieldset": {
                      borderColor: "rgba(17, 24, 39, 0.25)",
                    },
                  },
                }}
              />
            </Box>

            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}>
                Expiry
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  minDate={dayjs()}
                  value={
                    insuranceDetails.expiry
                      ? dayjs(insuranceDetails.expiry)
                      : null
                  }
                  onChange={(newValue) => {
                    setInsuranceDetails((prev) => ({
                      ...prev,
                      expiry: newValue ? newValue.format("YYYY-MM-DD") : "",
                    }));
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      placeholder: "Select The Date",
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          background: "#F3F4F6",
                          "& fieldset": {
                            borderColor: "rgba(17, 24, 39, 0.25)",
                          },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="contained"
              onClick={updateInsuranceDetails}
              sx={{
                background: "rgba(103, 60, 142, 1)",
                borderRadius: "10px",
                px: 4,
                py: 1.5,
                fontSize: "18px",
                fontWeight: 700,
                textTransform: "capitalize",
                color: "white",
                boxShadow: "none",
                "&:hover": {
                  background: "rgba(103, 60, 142, 1)",
                  boxShadow: "none",
                },
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InsuranceDetailsModal;
